class ScrollToTop extends HTMLElement {
    constructor() {
        super();
        this.scrollOffset = 300; // default fallback
    }

    connectedCallback() {
        this.initOffset();

        this._scrollHandler = this.debounce(this.handleScroll.bind(this), 50);

        this.addEventListener("click", this.scrollToTop.bind(this));
        window.addEventListener("scroll", this._scrollHandler);
    }

    disconnectedCallback() {
        window.removeEventListener("scroll", this._scrollHandler);
    }

    initOffset() {
        const attr = this.getAttribute("data-offset");

        if (attr !== null) {
            const parsed = parseInt(attr, 10);
            if (!isNaN(parsed)) {
                this.scrollOffset = parsed;
            }
        }
    }

    handleScroll() {
        if (window.scrollY > this.scrollOffset) {
            this.classList.add("show");
        } else {
            this.classList.remove("show");
        }
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    debounce(func, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }
}

if (!customElements.get("scroll-to-top")) {
    customElements.define("scroll-to-top", ScrollToTop);
}